import React, { useState } from "react";
import PropTypes from "prop-types";
import { CasesByAuthorJudgeInstitutionOutcomeChart, CasesByAuthorJudgeFWDOutcomeChart, CasesByPanelJudgeInstitutionOutcomeChart, CasesByPanelJudgeFWDOutcomeChart } from "./charts";
import { Divider, Select } from "antd";
import UserAccess from "@/components/common/user-access";

const CaseTabAuthorJudge = ({ query, router }) => {
  const [displaySize, setDisplaySize] = useState(20);
  const q = { ...query, size: displaySize };
  const navigateToCaseList = k => v =>
    router.push({
      pathname: `/ptab/judge/${encodeURIComponent(v.key)}`,
      query: { type: k }
    });
  const callToClick = <a>Cick to View Author Judge</a>;

  return (
    <UserAccess domain="ptab" showHelp={true}>
      <Select
        value={displaySize}
        placeholder="Display Size"
        onChange={setDisplaySize}
        getPopupContainer={trigger => trigger.parentNode}
        style={{ width: 180, marginTop: 15, marginLeft: 15 }}
      >
        {[20, 50, 100].map(e => (
          <Select.Option value={e} key={e}>{`Show Top ${e}`}</Select.Option>
        ))}
      </Select>
      <CasesByAuthorJudgeInstitutionOutcomeChart query={q} onValueClick={navigateToCaseList("author")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByAuthorJudgeFWDOutcomeChart query={q} onValueClick={navigateToCaseList("author")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByPanelJudgeInstitutionOutcomeChart query={q} onValueClick={navigateToCaseList("panel")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByPanelJudgeFWDOutcomeChart query={q} onValueClick={navigateToCaseList("panel")} tooltipExtraRow={callToClick} />
    </UserAccess>
  );
};
CaseTabAuthorJudge.propTypes = {
  query: PropTypes.object,
  router: PropTypes.object
};

export default CaseTabAuthorJudge;
